import _ from 'underscore';
import { bidStratetyTypeValue } from '@bingads-webui-campaign-react/constants';

export const isAutoBidding = (bidStrategyType) => {
  const autoBidding = [bidStratetyTypeValue.maximizeConversions, bidStratetyTypeValue.maximizeClicks, bidStratetyTypeValue.maxConversionValue, bidStratetyTypeValue.targetRoas, bidStratetyTypeValue.targetCpa, bidStratetyTypeValue.targetImpressionShare, bidStratetyTypeValue.costPerSale];
  const result = _.contains(autoBidding, bidStrategyType);

  return result;
};
